module.exports = __webpack_public_path__ + "img/rename-icon.25822675.svg";